import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

const EmptyLmsTrainingsComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="lms-courses-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No LMS courses found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery ? 'Try a different search.' : 'Add a course to get started.'}
      </Typography>
    </div>
  )
}

export const EmptyLmsTrainings = memo(EmptyLmsTrainingsComponent)
